var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pointer itemUsed",class:[_vm.labelSetColor + ' lighten-3'],on:{"!click":function($event){return _vm.editLodging(_vm.lodging)}}},[_c('div',{class:_vm.itemActive,staticStyle:{"height":"40px"}},[(_vm.toggleIconsLabel || _vm.toggleIconsAssistance)?[_c('status-icon',{attrs:{"lodging":_vm.lodging,"dayTable":_vm.date.numberDay,"toggleIconsAssistance":_vm.toggleIconsAssistance}}),(
						_vm.compareDates({
							text: true,
							start: _vm.lodging.start,
							end: _vm.lodging.end,
							dayTable: _vm.date.numberDay,
						})
					)?_c('div',{staticClass:"maxContent"},[(
							!_vm.lodging.userNotifications.length &&
								_vm.toggleIconsLabel &&
								!_vm.toggleIconsAssistance
						)?_c('div',{staticClass:"caption textIntoDIV"},[_c('v-icon',{attrs:{"dark":"","x-small":""}},[_vm._v(" mdi-bell-cancel ")])],1):_vm._e(),(
							!_vm.lodging.histories.length &&
								!_vm.toggleIconsLabel &&
								_vm.toggleIconsAssistance
						)?_c('div',{staticClass:"caption textIntoDIV"},[_c('v-icon',{attrs:{"dark":"","x-small":""}},[_vm._v(" mdi-alert-circle ")])],1):_vm._e()]):_vm._e()]:[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(
								_vm.compareDates({
									text: true,
									start: _vm.lodging.start,
									end: _vm.lodging.end,
									dayTable: _vm.date.numberDay,
								})
							)?_c('div',_vm._g(_vm._b({staticClass:"maxContent"},'div',attrs,false),on),[(!_vm.periodSelected)?_c('div',{staticClass:"caption textIntoDIV"},[_c('v-btn',{staticClass:"mr-1",staticStyle:{"width":"15px","height":"15px","font-size":"10px"},attrs:{"fab":"","x-small":"","elevation":"0","color":_vm.lodging.color != '#616161' && _vm.lodging.color
											? _vm.lodging.color
											: _vm.labelColor,"dark":""}},[_vm._v(" "+_vm._s(_vm.lodging.room.substring(0, 2))+" ")])],1):_vm._e()]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.lodging.room.substring(0, 15)))])])]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }